module.exports = __webpack_public_path__ + "ca285fb34dd23a52b9aff2a5f90bd51b.png";